<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <form @submit.prevent="submit">
      <div class="modal-card">
        <header class="modal-card-head">
          <h1 class="is-title-header modal-card-title">
            {{ action }}
          </h1>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <b-field label="Customer">
                <b-select
                  name="customer"
                  :disabled="!isAdd"
                  v-model="formData.customer"
                  expanded
                  placeholder="Please select"
                  required
                >
                  <option
                    v-for="(option, index) in customers"
                    :value="option.id"
                    :key="index"
                    selected
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Country">
                <b-select
                  expanded
                  required
                  name="country"
                  v-model="formData.country"
                  v-on:input="filterScheme"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in countries"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Scheme">
                <b-select
                  expanded
                  required
                  name="scheme"
                  v-model="formData.scheme"
                  v-on:input="filterStream"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in schemes"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Stream">
                <b-select
                  expanded
                  required
                  name="stream"
                  v-model="formData.stream"
                  v-on:input="filterReportingTypes"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in streams"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <!-- <b-field label="Report Type">
                <b-select
                  name="report"
                  v-model="formData.report"
                  expanded
                  :disabled="!isAdd"
                  v-on:input="filterReportingTypes"
                  placeholder="Please select (optional)"
                >
                  <option
                    v-for="(option, index) in reports"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.report_type }}
                  </option>
                </b-select>
              </b-field> -->
              <b-field label="Reporting Category">
                <b-select
                  expanded
                  required
                  name="reporting_category"
                  v-model="formData.reporting_main_category"
                  :disabled="!isAdd"
                  placeholder="Please select"
                  v-on:input="filterReportingSubCategories"
                >
                  <option
                    v-for="(option, index) in reportingCategories"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.main_category }}
                  </option>
                </b-select>
              </b-field>
              <b-field
                label="Reporting Sub Category"
                v-if="reportingSubCategories"
              >
                <b-select
                  expanded
                  name="reporting_sub_category"
                  v-model="formData.reporting_sub_category"
                  :disabled="!isAdd"
                  placeholder="Please select"
                >
                  <option
                    v-for="(option, index) in reportingSubCategories"
                    :value="option.id"
                    :key="index"
                  >
                    {{ option.sub_category }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Valid From">
                <b-datepicker
                  name="valid_from"
                  :disabled="!isAdd"
                  v-model="formData.valid_from"
                  :date-formatter="dateFormatter"
                  icon="calendar-today"
                  trap-focus
                  editable
                  required
                >
                  <b-button
                    type="is-danger"
                    @click="formData.valid_from = null"
                  >
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </b-button>
                </b-datepicker>
              </b-field>
              <b-field label="Valid To">
                <b-datepicker
                  name="valid_to"
                  :disabled="!isAdd"
                  v-model="formData.valid_to"
                  :date-formatter="dateFormatter"
                  icon="calendar-today"
                  trap-focus
                  editable
                  required
                >
                  <b-button type="is-danger" @click="formData.valid_to = null">
                    <b-icon icon="close"></b-icon>
                    <span>Clear</span>
                  </b-button>
                </b-datepicker>
              </b-field>
              <b-field label="Example of Product">
                <b-input
                  type="textarea"
                  :disabled="!isAdd"
                  name="additional_info"
                  v-model="formData.example_of_product"
                ></b-input>
              </b-field>
              <b-field label="Additional Information">
                <b-input
                  type="textarea"
                  name="additional_info"
                  v-model="formData.additional_info"
                  :disabled="!isAdd"
                />
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" v-if="isAdd">
          <b-button slot="right" native-type="submit" type="is-primary">
            Save
          </b-button>
          <b-button slot="right" type="is-danger" @click="cancel">
            Cancel
          </b-button>
        </footer>
        <footer class="modal-card-foot" v-if="!isAdd">
          <b-button
            v-if="disable && this.action !== 'View'"
            slot="right"
            type="is-danger"
            @click="remove"
          >
            Delete
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import ReportingTrackerDataService from "@/services/ReportingTrackerDataService";
import ReportingCategoryService from "@/services/ReportingCategoryService";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import SchemeDataService from "../../services/SchemeDataService";
export default {
  name: "ReportingCategoryAdd",
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    isAdd: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    editObjectName: {
      type: Object,
      default: () => {
        return {
          customer: "",
          country: "",
          scheme: "",
          stream: "",
          short_report_name: "",
          reporting_main_category: null,
          reporting_sub_category: null,
          valid_from: null,
          valid_to: null,
          example_of_product: "",
          additional_info: ""
        };
      }
    },
    customerId: {
      type: Number,
      default: -1
    },
    country: {
      type: Array,
      default: null
    },
    scheme: {
      type: Array,
      default: null
    },
    container: {
      type: Array,
      default: null
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isModalActive: false,
      customers: [],
      reportingCategories: [],
      reportingSubCategories: [],
      customerDataService: new CustomerProfileDataService(),
      schemeDataService: new SchemeDataService(),
      reportingCategoryService: new ReportingCategoryService(),
      reportingTrackerService: new ReportingTrackerDataService(),
      countries: [],
      streams: [],
      schemes: [],
      reports: [],
      formData: {}
    };
  },
  mounted() {
    //this.fetchReportingTrackerData();
    this.fetchCustomerList();
  },
  computed: {
    disable() {
      if (this.action == "Edit") {
        return false;
      } else if (this.action == "View") {
        return true;
      } else if (this.action == "Delete") {
        return true;
      }
      return false;
    }
  },
  methods: {
    // fetchReportingTrackerData() {
    //   this.reportingTrackerService.getAllReports().subscribe(
    //     response => {
    //       this.reports = response;
    //       console.log(response);
    //     },
    //     e => {
    //       console.log(e);
    //     }
    //   );
    // },
    checkChoosenField() {
      this.formData.fee_per_kg = null;
      this.formData.fee_per_unit = null;
    },
    filterEditSchemeStream() {
      if (this.formData.country) {
        this.schemeDataService.getByCountry(this.formData.country).subscribe(
          response => {
            this.schemes = response;
            this.schemeDataService.get(this.formData.scheme).subscribe(
              response => {
                this.streams = response["container"];
                this.reportingCategoryService
                  .getReportingTypes(this.formData)
                  .subscribe(
                    response => {
                      this.reportingCategories = response;
                      this.reportingSubCategories = [];
                      const filterReport = this.reportingCategories.filter(
                        i => i.main_category == this.formData.main_category
                      );
                      this.formData.reporting_main_category =
                        filterReport[0].id;
                      this.reportingSubCategories =
                        filterReport[0].sub_category;
                      const filterSubReport = this.reportingSubCategories.filter(
                        i => i.sub_category == this.formData.sub_category
                      );
                      this.formData.reporting_sub_category =
                        filterSubReport[0].id;
                    },
                    e => {
                      console.log(e);
                    }
                  );
              },
              e => {
                console.log(e);
              }
            );
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    filterScheme(countryId) {
      // Reset all dependent fields in form data when country changes
      this.formData.scheme = null;
      this.formData.stream = null;
      this.formData.reporting_main_category = null;
      this.formData.reporting_sub_category = null;

      // Reset the data arrays for dropdowns
      this.streams = [];
      this.reportingCategories = [];
      this.reportingSubCategories = [];

      // Fetch new schemes for the selected country
      this.schemeDataService.getByCountry(countryId).subscribe(
        response => {
          this.schemes = response;
        },
        e => {
          console.log(e);
        }
      );
    },
    filterStream(schemeId) {
      // Reset dependent fields in form data when scheme changes
      this.formData.stream = null;
      this.formData.reporting_main_category = null;
      this.formData.reporting_sub_category = null;

      // Reset the data arrays for dependent dropdowns
      this.reportingCategories = [];
      this.reportingSubCategories = [];

      if (schemeId) {
        // Fetch streams for the selected scheme
        this.schemeDataService.get(schemeId).subscribe(
          response => {
            this.streams = response["container"];
          },
          e => {
            console.log(e);
          }
        );
      } else {
        // If no scheme is selected, clear the streams
        this.streams = [];
      }
    },
    // filterReports(streamId) {
    //   this.formData.report = null;
    //   this.reportingTrackerService
    //     .getReportBySchemeStream(this.formData.scheme, streamId, true)
    //     .subscribe(
    //       response => {
    //         this.reports = response;
    //         this.filterReportingTypes();
    //       },
    //       e => {
    //         console.log(e);
    //       }
    //     );
    // },
    filterEditReportingSubCategories(reportingCategory) {
      if (reportingCategory) {
        this.reportingCategoryService
          .getReportingTypes(this.formData)
          .subscribe(
            response => {
              this.reportingCategories = response;
              const data = this.reportingCategories.filter(
                i => reportingCategory == i.id
              );
              if (data.length > 0) {
                this.reportingSubCategories = data[0].sub_category;
              }
            },
            e => {
              console.log(e);
            }
          );
      }
    },
    checkReportingSubCategories(value) {
      if (value) {
        const data = this.reportingSubCategories.filter(
          i => value == i.sub_category
        );
        this.formData.reporting_category_id = data[0].id;
      }
    },
    filterReportingSubCategories(reportingCategory) {
      // Reset the reporting sub-category when the main category changes
      this.formData.reporting_sub_category = null;

      if (reportingCategory) {
        const data = this.reportingCategories.filter(
          i => reportingCategory == i.id
        );
        if (data.length > 0) {
          this.reportingSubCategories = data[0].sub_category;
        } else {
          this.reportingSubCategories = [];
        }
      } else {
        // If no reporting category is selected, clear sub-categories
        this.reportingSubCategories = [];
      }
    },
    filterReportingTypes() {
      // Reset reporting categories data when stream changes
      this.formData.reporting_main_category = null;
      this.formData.reporting_sub_category = null;

      // Reset the sub-categories array
      this.reportingSubCategories = [];

      if (
        this.formData.country &&
        this.formData.scheme &&
        this.formData.stream
      ) {
        // Fetch reporting categories based on selected country, scheme, and stream
        this.reportingCategoryService
          .getReportingTypes(this.formData)
          .subscribe(
            response => {
              this.reportingCategories = response;
            },
            e => {
              console.log(e);
            }
          );
      } else {
        // If any of the required fields is missing, clear the reporting categories
        this.reportingCategories = [];
      }
    },
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    dateParser(dt) {
      return new Date(Date.parse(dt));
    },
    fetchCustomerList() {
      this.customerDataService.getCustomerList(this.customerId, true).subscribe(
        customerProfiles => {
          this.customers = customerProfiles;
        },
        e => {
          console.log(e);
        }
      );
    },
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },

    handleApiError(reason) {
      let errorMessage = "";
      for (const v in reason.response.data) {
        errorMessage += v + ": " + reason.response.data[v] + "<br>";
      }

      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    submit() {
      //if (this.formData.reporting_category_id) {
      if (this.action == "Add") {
        this.reportingCategoryService
          .create(this.formData)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Reporting Category is Created!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      } else if (this.action == "Update") {
        this.reportingCategoryService
          .update(this.formData)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Reporting Category is Updated!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      }
    },
    remove() {
      this.reportingCategoryService
        .delete(this.formData.id)
        .subscribe(response => {
          this.$emit("confirm", response);
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Reporting Category is Removed!"
          });
        }, this.handleApiError);
    },
    convertToDate(dt) {
      let newDate = null;
      if (dt == " - ") {
        return newDate;
      }
      if (dt != null) {
        newDate = new Date(dt);
      }
      return newDate;
    }
  },
  watch: {
    editObjectName(newValue) {
      this.formData = newValue;
      if (this.formData.entity_id) {
        this.formData.customer = newValue.entity_id;
      } else {
        this.formData.customer = newValue.customer_id;
      }
      this.formData.country = newValue.country_id;
      this.formData.scheme = newValue.scheme_id;
      this.formData.stream = newValue.stream_id;
      this.formData.example_of_product = newValue.example_product;
      this.formData.valid_from = this.convertToDate(newValue.valid_from);
      this.formData.valid_to = this.convertToDate(newValue.valid_to);
      this.formData.main_category = newValue.main_category;
      this.formData.sub_category = newValue.sub_category;
      this.filterEditSchemeStream(this.formData);
      // console.log(newValue.main_category, this.reportingCategories);
    },
    action(newValue) {
      if (newValue == "Add") {
        this.formData = {
          customer: "",
          country: "",
          scheme: "",
          stream: "",
          short_report_name: "",
          reporting_main_category: null,
          reporting_sub_category: null,
          valid_from: null,
          valid_to: null,
          example_of_product: "",
          additional_info: ""
        };
      }
    },
    country(newValue) {
      this.countries = newValue;
    },
    container(newValue) {
      this.streams = newValue;
    },
    scheme(newValue) {
      this.schemes = newValue;
    },
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
